import React  from 'react';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import './App.css';
import './Notebook.css';
import './NotebookNewPopup.css';
import NotebookLang from './NotebookLang.json';

import { useNavigate } from "react-router-dom";

class NotebookNewPopup extends React.Component {

	constructor(props) {

		super(props);

		this.state = {
			title: "",
			notebookCreateYN: false,
		}
	}
		
	onKeyDown(keyCode) {
		if (keyCode === 13) {
			this.onClickSaveButton();
		}
	}

	onPopUpClosed() {
		this.props.setNotebookNewPopupYN(false);
	}

	onTitleChanged(value) {
		this.setState({title: value});
	}
	
	async serverInsertNotebookRecord(title, companyID, userID, userFullName) {
		
		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/insertnotebookrecord?title=" + encodeURIComponent(title);
		url = url + "&companyid=" + companyID;
		url = url + "&userid=" + userID;
		url = url + "&userfullname=" + encodeURIComponent(userFullName);
		
		var responseText = "";
		
		try {
			var res = await fetch(url);
			responseText = await res.text();
		} catch (err) {
		}

		return responseText;
	}

	async onClickSaveButton() {
		
		var title = this.state.title;
		title = title.trim();
		if (title === "") {
			this.props.showToast(this.props.getLang(NotebookLang, "titleIsEmpty"));
			return;
		}
		
		this.setState({notebookCreateYN: true});

		var companyID = this.props.companyID;
		var userID = this.props.userID;
		var fullName = this.props.fullName;

		await this.serverInsertNotebookRecord(title, companyID, userID, fullName);
		this.setState({
			title: "",
			notebookCreateYN: false,
		});

		var toastString = this.props.getLang(NotebookLang, "notebookCreated");
		this.props.showToast(toastString);
		this.onPopUpClosed();
		this.props.refreshData();
	}
	
	onClickCancelButton() {
		this.onPopUpClosed();
	}

	renderButtons() {
		
		var notebookCreateYN = this.state.notebookCreateYN;
		if (notebookCreateYN) {
			return;
		}

		return (
			<div className="ViewContainerButtons2">
				<button className="ViewCancelButton" onClick={() => this.onClickCancelButton()}>{this.props.getLang(NotebookLang, "cancel")}</button>
				<div style={{width: "20px"}}></div>
				<button className="ViewSaveButton" onClick={() => this.onClickSaveButton()}>{this.props.getLang(NotebookLang, "save")}</button>
			</div>
		);
	}
	
	renderContent() {

		var title = this.state.title;
		
		return (
			<div className="NotebookNewPopupTopContainer">
				<div style={{height: "10px"}}></div>
				<div className="NotebookNewPopupTitle">{this.props.getLang(NotebookLang, "newNotebook")}</div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				<div className="ViewContainer2">
					<fieldset className="NotebookNewPopupFieldset">
						<legend className="NotebookNewPopupLegend">{this.props.getLang(NotebookLang, "notebookTitle")}</legend> 
						<input
							className="NotebookNewPopupInput" 
							autoFocus={true}
							id="title" 
							type="text" 
							value={title}
							onChange={(event) => this.onTitleChanged(event.target.value)}
							onKeyDown={(event) => this.onKeyDown(event.keyCode)}
						/>
					</fieldset>
				</div>
				<div style={{height: "30px"}}></div>
				{this.renderButtons()}
				<div style={{height: "20px"}}></div>				
			</div>
		);
	}
	
	render() {
		
		var renderPopupYN = this.props.renderPopupYN;
		
		if (!renderPopupYN) {
			return null;
		}

		return (
			<Popup
				className="notebook-new-popup"
				open={true}
				closeOnEscape
				closeOnDocumentClick
				onClose={() => this.onPopUpClosed()}
			>
				{this.renderContent()}
			</Popup>
		);
	}
}

export default function NotebookNewPopupFunction(props) {
	const navigate = useNavigate();
	return <NotebookNewPopup {...props} navigate={navigate} />;
}


